// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"285":"04c23d6b","709":"0b6c6d96"}[chunkId] + ".chunk.js";
};